import { AuthService } from '../../auth/auth.service';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // don't include the bearer token if annonymous header exists
    if (request.headers.has('Annonymous')) {
      request.headers.delete('Annonymous');
      return next.handle(request);
    }
    const accessToken: string = this._authService.getAccessToken();
    const tenant: string = this._authService.getTenant();
    request = request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + accessToken,
        'x-tenant': tenant,
      },
    });
    return next.handle(request);
  }
}
